"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayPrice = exports.setCurrencyFormat = void 0;
var constants_1 = require("./constants");
var region_1 = require("../region");
var currencyFormat = constants_1.currencyFormatMap[region_1.currentCid || region_1.CidMap.id];
var setCurrencyFormat = function (formatMap) {
    var cid = region_1.currentCid || region_1.CidMap.id;
    currencyFormat = formatMap[cid] || constants_1.currencyFormatMap[cid];
};
exports.setCurrencyFormat = setCurrencyFormat;
/**
 * 根据地区显示价格
 * @param params
 * @param preNeedCurrency
 * @returns
 */
var displayPrice = function (params, preNeedCurrency) {
    if (preNeedCurrency === void 0) { preNeedCurrency = true; }
    var resultPrice;
    var curNeedCurrency = preNeedCurrency;
    var curMinimumDigits;
    var curUseGrouping = true;
    if (typeof params === 'string' || typeof params === 'number') {
        resultPrice = String(params);
    }
    else {
        var _a = params || {}, price = _a.price, _b = _a.needCurrency, needCurrency = _b === void 0 ? true : _b, minimumDigits = _a.minimumDigits, useGrouping = _a.useGrouping;
        resultPrice = String(price);
        curNeedCurrency = needCurrency;
        curMinimumDigits = minimumDigits;
        curUseGrouping = useGrouping;
    }
    if (!resultPrice || isNaN(parseFloat(resultPrice)))
        return '';
    return parseFloat(resultPrice).toLocaleString(currencyFormat.locale, {
        style: curNeedCurrency ? 'currency' : 'decimal',
        currency: currencyFormat.currency,
        maximumFractionDigits: 5,
        useGrouping: curUseGrouping,
        minimumFractionDigits: curMinimumDigits !== undefined ? curMinimumDigits : currencyFormat.minimumFractionDigits,
    });
};
exports.displayPrice = displayPrice;
